<template>
    <div>
        <b-row>
            <b-col md="12">
                <component-header
                    title="Webhook Integration"
                    :hasSearch="false"
                    :hasReload="false"
                    :hasCreate="true"
                    createButtonText="Add"
                    :hasback="false"
                    @create-press="showModal = true"
                />
            </b-col>
            <b-col>
                <b-card>
                    <b-row>
                        <b-col md="12">
                            <b-table
                                :dark="dark"
                                :hover="hover"
                                :striped="striped"
                                :bordered="bordered"
                                :small="small"
                                :fixed="fixed"
                                responsive
                                id="my-table"
                                :current-page="currentPage"
                                :per-page="perPage"
                                :items="list"
                                thead-class="header"
                                class="mt-3"
                                :fields="columns"
                                show-empty
                                @filtered="onFilter"
                            >
                                <template
                                    slot="cell(endpointUrl)"
                                    slot-scope="data"
                                >
                                    <b-button
                                        size="sm"
                                        class="button-circle"
                                        variant="primary"
                                        v-b-modal="`modal-${data.index}`"
                                    >
                                        <i class="fa fa-eye"></i>
                                    </b-button>
                                    <b-modal
                                        :id="`modal-${data.index}`"
                                        :ref="`modal-${data.index}`"
                                        title="Endpoint"
                                        centered
                                        ok-only
                                    >
                                        <p
                                            class="my-4"
                                            v-for="(item, k) in data.item
                                                .endpointUrl"
                                            :key="k"
                                        >
                                            {{ item }}
                                        </p>
                                    </b-modal>
                                </template>
                                <template slot="cell(action)" slot-scope="data">
                                    <b-button
                                        size="sm"
                                        class="button-circle"
                                        @click="deleteEventById(data.item)"
                                        variant="danger"
                                    >
                                        <i class="fa fa-trash"></i>
                                    </b-button>
                                </template>
                            </b-table>
                            <div style="float: right">
                                <b-pagination
                                    v-model="currentPage"
                                    :per-page="perPage"
                                    :total-rows="filterCount"
                                    aria-controls="my-table"
                                    prev-text="Prev"
                                    next-text="Next"
                                    hide-goto-end-buttons
                                ></b-pagination>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-modal
            id="modal-add"
            ref="modal-add"
            title="Add Event"
            centered
            v-model="showModal"
            no-close-on-backdrop
            hide-footer
        >
            <b-row class="mt-2">
                <b-col md="12">
                    <div class="form-group">
                        <v-select
                            variant="outlined"
                            v-model="selectedEvent"
                            :items="eventList"
                            label="Select Event"
                        >
                        </v-select>
                    </div>
                </b-col>
            </b-row>
            <div
                v-for="(endpoint, index) in endpoints"
                :key="index"
                class="mb-2"
            >
                <b-row>
                    <b-col :md="gridInfo.lg" class="pr-0">
                        <!-- <b-input
                      v-model="endpoints[index]"
                      placeholder="Enter endpoint"
                      style="width: 97%"
                    /> -->
                        <textarea
                            v-model="endpoints[index]"
                            placeholder="Enter endpoint"
                            class="scrollabletextbox"
                        ></textarea>
                    </b-col>
                    <b-col :md="gridInfo.sm" class="pl-0">
                        <b-button
                            btn-special="danger"
                            size="sm"
                            @click="addNewField(index)"
                            style="height: 39px; width: 100%"
                            class="mr-1"
                        >
                            <i class="fa fa-plus-circle"></i> Add
                        </b-button>
                        <b-button
                            btn-special="danger"
                            size="sm"
                            @click="removeEndpoint(index)"
                            style="height: 39px"
                            v-if="index > 0 || endpoints.length > 1"
                        >
                            <i class="fa fa-minus-circle"></i> Remove
                        </b-button>
                    </b-col>
                </b-row>
            </div>
            <div class="text-center mb-5 mt-2 p-3">
                <button
                    variant="danger"
                    type="button"
                    @click="closeModal"
                    class="btn btn-lg btn-outline-danger mr-3 w-25"
                >
                    CANCEL
                </button>
                <button
                    type="button"
                    class="btn btn-lg btn-outline-success ml-3 w-25"
                    @click="addWebhookEvent"
                >
                    ADD
                </button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import profile from "@/components/profile/profileCategory";
import ComponentHeader from "@/components/componentNewHeader";
export default {
    components: {
        profile,
        ComponentHeader,
    },
    data() {
        return {
            filterCount: 0,
            loading: false,
            perPage: 10,
            currentPage: 1,
            filter: "",
            loading: false,
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            dark: false,
            eventList: [],
            selectedEvent: "",
            filterCount: 0,
            endpoints: [""],
            columns: [
                {
                    key: "eventName",
                },
                {
                    key: "endpointUrl",
                },
                // {
                //   key: "secret_key",
                // },
                // {
                //   key: "passcode",
                // },
                {
                    key: "action",
                },
            ],
            list: [],
            showModal: false,
        };
    },
    computed: {
        gridInfo() {
            if (this.endpoints.length > 1) {
                return {
                    lg: 8,
                    sm: 4,
                };
            } else {
                return {
                    lg: 9,
                    sm: 3,
                };
            }
        },
    },
    methods: {
        onFilter(list) {
            this.filterCount = list.length;
            this.currentPage = 1;
        },
        deleteEventById(item) {
            this.$swal({
                title: "Warning",
                text: "Are you sure? You won't be able to revert this!",
                type: "warning",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes, Delete it!",
                showCancelButton: true,
            }).then((result) => {
                if (result.value) {
                    const payload = {
                        id: item._id,
                    };
                    try {
                        this.$store
                            .dispatch("profile/deleteEvent", payload)
                            .then((res) => {
                                if (res.data) {
                                    this.$toasted.success(
                                        "Event deleted successfully....",
                                    );
                                    this.fetchList();
                                }
                            });
                    } catch (e) {
                        this.$swal({
                            title: "Error",
                            text: "Error occured while deleting event...",
                            type: "error",
                        });
                    }
                }
            });
        },
        resetModalData() {
            this.selectedEvent = null;
            this.endpoints = [""];
        },
        closeModal() {
            this.$refs["modal-add"].hide();
            this.resetModalData();
        },
        removeEndpoint(index) {
            this.endpoints.splice(index, 1);
        },
        async addWebhook() {
            const payload = {
                tenant: this.$currentUserData._id,
            };
            try {
                await this.$store.dispatch("profile/addWebhook", payload);
            } catch (e) {
                this.$swal({
                    title: "Error",
                    text: "Error occured while registering tenant...",
                    type: "error",
                });
            }
        },
        addNewField(ind) {
            if (this.endpoints[ind].length < 1) {
                this.$toasted.error("input field should not be empty!");
                return;
            }
            let newArr = [
                ...this.endpoints.slice(0, ind + 1),
                "",
                ...this.endpoints.slice(ind + 1),
            ];
            this.endpoints = [...newArr];
        },
        async addWebhookEvent() {
            if (this.selectedEvent !== null && this.selectedEvent.length < 1) {
                this.$toasted.error("Please select an event");
                return;
            }
            if (this.endpoints.length < 1 || this.endpoints[0].length < 1) {
                this.$toasted.error("Please enter atleast one endpoint");
                return;
            }
            let endPoint = this.endpoints.filter((el) => el.length);
            const payload = {
                tenant: this.$currentUserData._id,
                eventName: this.selectedEvent,
                endpointUrl: endPoint,
            };
            await this.$store
                .dispatch("profile/addWebhookEvent", payload)
                .then((res) => {
                    if (res.data) {
                        this.$toasted.success("Event added successfully..");
                        this.$refs["modal-add"].hide();
                        this.resetModalData();
                        this.fetchList();
                    }
                });
        },

        async fetchEventList() {
            const data = await this.$store.dispatch("profile/eventList");
            this.eventList = data.data.result.EVENTS || [];
        },
        async fetchList() {
            const payload = {
                id: this.$currentUserData._id,
            };
            const data = await this.$store.dispatch(
                "profile/webhookEventList",
                payload,
            );
            this.list =
                data.data.result[0].webhookDetails.filter(
                    (x) => !x.isDeleted,
                ) || [];
        },
    },
    async mounted() {
        await this.addWebhook();
        await this.fetchEventList();
        await this.fetchList();
    },
    created() {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    },
};
</script>

<style scoped>
.scrollabletextbox {
    height: 38px;
    width: 97%;
    overflow-y: scroll;
    border: 1px solid rgb(144, 144, 144) !important;
    border-radius: 5px;
    padding: 7px;
}
</style>
